import { defineComponent as _defineComponent } from 'vue'
import LButton from '@/components/core/Button.vue'
import { useSelectedTrip } from '@/composables/trip'
import { RouteWithEmoji, useTransportationStore } from '@/stores/transportation'
import { formattedDistance } from '@/utils/utility-manager'
import { formattedDuration } from '@/utils/date-utils'
import { useLocalTripSettings } from '@/composables/trip-settings'


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteItem',
  props: {
    route: null,
    index: null,
    isSelectedRoute: { type: Boolean }
  },
  setup(__props: any) {



const trip = useSelectedTrip()
const transportationStore = useTransportationStore()

const { tripSettings } = useLocalTripSettings(trip.value._id)

return { __sfc: true,trip, transportationStore, tripSettings, LButton, formattedDistance, formattedDuration }
}

})